/* Title-only substring search. Exact IDs keep Shopify cards, facets and pagination native. */
(function () {
  'use strict';
  const marker = '((id:0 AND title:"__bw_title_v1_';
  const suffix = ') AND -tag:balance AND -tag:search_hide';
  const normalize = value => String(value || '').normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();
  const eligible = p => !Number(p.hidden) && !(p.tags || []).some(t => /^(balance|search_hide)$/i.test(t));
  function displayTerm(value) {
    const raw = String(value || '');
    if (raw.startsWith(marker)) {
      try { return decodeURIComponent(raw.slice(marker.length).split('"')[0]); } catch (_) { return ''; }
    }
    if (raw.startsWith('((title:"') && raw.endsWith(suffix)) return raw.slice(9).split('" OR variants.sku:')[0];
    return raw;
  }
  function resolve(value, data) {
    const term = displayTerm(value).trim(), needle = normalize(term);
    const hits = needle ? data.products.filter(p => eligible(p) && normalize(p.title).includes(needle)) : [];
    const ids = [...new Set(hits.map(p => Number(p.id)))].sort((a,b) => a-b);
    if (ids.some(id => !Number.isSafeInteger(id) || id <= 0)) throw new Error('Invalid product index');
    const query = marker + encodeURIComponent(term) + '") OR ' + (ids.map(id => 'id:' + id).join(' OR ') || 'id:0') + suffix;
    // Do not silently omit matches or fall back to unrelated Shopify results.
    if (encodeURIComponent(query).length > 12000) throw new Error('Search result query too large');
    return {query, canonical:term, expectedIds:ids};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {resolve, normalize, eligible, displayTerm}; return; }
  let indexPromise;
  function endpoint(section, term, page) {
    const url = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
    url.searchParams.set('section_id', section);
    url.searchParams.set('q', term || '*');
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'show');
    if (page) url.searchParams.set('page', page);
    return url;
  }
  async function request(url, signal) {
    const response = await fetch(url, {signal, credentials:'same-origin'});
    if (!response.ok) throw new Error('Search response ' + response.status);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async function loadIndex() {
    if (!indexPromise) indexPromise = (async () => {
      const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const data = {products:[]};
        for (let page=1, pages=1; page<=pages; page++) {
          const doc = await request(endpoint('bw-search-index', '*', page), controller.signal);
          const chunk = JSON.parse(doc.querySelector('[data-bw-search-index]').textContent);
          if (!Array.isArray(chunk.products) || chunk.page !== page || !Number.isInteger(chunk.pages) || chunk.pages < 1 || chunk.pages > 10) throw new Error('Search index incomplete');
          data.products.push(...chunk.products); pages = chunk.pages;
        }
        data.products = [...new Map(data.products.map(p => [p.id,p])).values()];
        return data;
      } finally { clearTimeout(timeout); }
    })().catch(error => { indexPromise = null; throw error; });
    return indexPromise;
  }
  async function expand(term) { return resolve(term, await loadIndex()); }
  function showError(container) {
    let note = container.querySelector('[data-bw-search-error]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.bwSearchError = ''; note.setAttribute('role','alert');
      note.style.cssText = 'padding:12px; background:#fff; color:#111; font-size:14px;';
      container.appendChild(note);
    }
    note.textContent = 'Search could not load. Please try again.';
  }
  window.BWRelatedSearch = {expand, resolve, displayTerm, loadIndex, endpoint, request, showError};
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search' || event.defaultPrevented) return;
    const input = form.querySelector('input[name="q"]'), term = input?.value.trim();
    if (!term || form.querySelector('[aria-selected="true"] a')) return;
    event.preventDefault();
    if (form.dataset.bwSearching) return;
    form.dataset.bwSearching = 'true'; form.setAttribute('aria-busy','true');
    form.querySelector('[data-bw-search-error]')?.remove();
    try {
      const match = await expand(term);
      if (input.value.trim() !== term) return;
      const url = new URL(form.action, location.origin);
      url.search = new URLSearchParams(new FormData(form)).toString();
      url.searchParams.set('q', match.query); url.searchParams.set('type','product');
      url.searchParams.set('options[unavailable_products]','show');
      url.searchParams.set('sort_by','relevance');
      location.assign(url.href);
    } catch (_) { showError(form); }
    finally { delete form.dataset.bwSearching; form.removeAttribute('aria-busy'); }
  });
})();
